<template>
<div class="content-body tenant-settings">
    <div class="">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" size="small">
            <el-form-item label="项目名:">
                <el-input size="small" v-model="dataForm.projectName" placeholder="项目名" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="报价单编码:">
                <el-input size="small" v-model="dataForm.rfqCode" placeholder="报价单编码" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item label="报价单状态:">
                <el-input size="small" v-model="dataForm.quotationtatus" placeholder="报价单状态" clearable @blur="getDataList"></el-input>
            </el-form-item>
            <el-form-item class="fr">
                <el-button size="small" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
                <el-button size="small" v-if="isAuth('sys:org:newQuotation')" type="primary" plain @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新建报价
                </el-button>
                <!-- <el-button size="small" v-if="isAuth('sys:org:savebutton')" type="primary" @click="addOrUpdateHandle()" icon="el-icon-plus">
                    导入报价
                </el-button> -->
            </el-form-item>
        </el-form>
        <div v-loading="dataListLoading">
            <el-table :data="dataList" row-key="index" size="mini" bQotation style="width: 100%;" :header-cell-style="{background:'#f5f5f5'}" :default-expand-all="false" border :height="tableHeight">
                <el-table-column type="index" width="50" label="序号">
                    <template slot-scope="scope">
                        {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="taskCode" header-align="center" align="left" label="任务编码" width="140">
                </el-table-column> -->
                <el-table-column prop="projectName" header-align="center" align="left" label="项目名称">
                </el-table-column>
                <el-table-column prop="rfqCode" header-align="center" align="left" label="报价单编码" width="140">
                </el-table-column>
                <el-table-column prop="rfqName" header-align="center" align="left" label="报价单名称">
                </el-table-column>
                <!-- <el-table-column prop="quotationName" header-align="left" align="left" label="报价单名称">
            </el-table-column> -->
                <el-table-column prop="rfqType" header-align="center" align="center" label="报价单类型" width="130">
                    <template slot-scope="scope">
                        {{getTechnicalValue(scope.row.rfqType)}}
                    </template>
                </el-table-column>
                <el-table-column prop="times" header-align="center" align="right" label="轮次" width="80">
                </el-table-column>
                <el-table-column prop="venderId" v-if="false" header-align="center" align="left" label="供应商ID">
                </el-table-column>
                <!-- 好像没有 -->
                <el-table-column prop="quotationStopTime" header-align="center" align="right" label="报价截止日期" :formatter="dateFormat" width="150">
                </el-table-column>
                <!-- 报价开始 报价完毕 比价开始 报价通过(审批) 报价通知 签署合同&协议 延期报价-->
                <el-table-column prop="rfqStatus" header-align="center" align="center" label="状态" width="100">
                    <template slot-scope="scope">
                        <span :class="getStatusClass(scope.row.rfqStatus)">
                            {{RFQ_STATUS_VALUE(scope.row.rfqStatus)}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="rfqCreateTime" header-align="center" align="right" label="创建时间" :formatter="dateFormat" width="150">
                </el-table-column>
                <el-table-column header-align="center" align="left" min-width="120" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="viewHandle(scope.row)" icon="el-icon-view">
                            查看
                        </el-button>
                        <el-button type="text" :disabled="![RFQ_STATUS.BEGIN, RFQ_STATUS.BEFORE_ASK, RFQ_STATUS.ASKING].includes(scope.row.rfqStatus)" size="small" @click="addOrUpdateHandle(scope.row)" icon="el-icon-edit">
                            报价
                        </el-button>
                        <!-- <el-button type="text" size="small" @click="deleteHandle(scope.row.id)" icon="el-icon-delete" class="button-danger">
                            删除
                        </el-button> -->
                        <el-button type="text" size="small" @click="exportRfq(scope.row)" icon="el-icon-edit">
                            导出询价函
                        </el-button>
                        <el-button type="text" size="small" @click="exportConfirm(scope.row)" icon="el-icon-edit">
                            导出价格确认书
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
            </el-pagination>
        </div>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" :vender="vender" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
</div>
</template>

<script>
import {
    listQuotationBySupplierId,
    deleteQuotation,
    exportRfq,
    exportConfirm
} from '@/controller/quotation'
import AddOrUpdate from './quotation-add-or-update'
import moment from 'moment'
import {
    RFQ_STATUS,
    getRFQ_STATUS_VALUE,
    QUOTATION_STATUS_VALUE,
    getLabelByValue,
    getTechnicalValue
} from '@/utils/const'
// require('@/mock/mockQuotation');
export default {
    data() {
        return {
            venderId: null,
            vender: {},
            documentClientHeight: document.documentElement['clientHeight'] - 250,
            dataForm: {
                rfqCode: '',
                projectName: '',
                quotationStatus: ''
            },
            RFQ_STATUS: RFQ_STATUS,
            RFQ_STATUS_VALUE: getRFQ_STATUS_VALUE,
            getTechnicalValue: getTechnicalValue,
            dataList: [],
            tenantList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false,
        }
    },
    computed: {
        tableHeight: {
            get() {
                return this.$store.state.common.documentClientHeight - 220
            }
        }
    },
    components: {
        AddOrUpdate,
    },
    activated() {
        this.init();
    },

    methods: {
        init() {

        },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
        // 新增或编辑子节点
        addChildHandle(id, parentId, parentName, parentNodePath) {

            console.log(id, parentId, parentName, parentNodePath)
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(null, parentId, parentName, parentNodePath)
            })
        },
        // 获取数据列表
        getDataList() {
            if (!this.vender) {
                console.log('无效供应商')
                return
            }
            this.dataListLoading = true
            listQuotationBySupplierId({
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
                totalPage: this.totalPage,
                venderId: this.vender.id,
                ...this.dataForm
            }).then(data => {
                if (data && data.code === '00') {
                    this.dataList = data.body.records
                    this.totalPage = data.body.total
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
            }).catch((e) => {
                console.log(e)
            }).finally(() => {
                this.dataListLoading = false
            })
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val
            this.pageIndex = 1
            this.getDataList()
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val
            this.getDataList()
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },
        // 查看
        viewHandle(row) {
            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : 0, true, 0, null, null, null)
            })
        },
        // 新增 / 修改
        addOrUpdateHandle(row) {

            this.addOrUpdateVisible = true
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(row, row ? row.id : 0, false, 0, null, null, null)
            })
        },
        // 删除
        deleteHandle(id) {
            console.log(id)
            this.$confirm(`确定进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteQuotation({}, id).then(data => {
                    if (data && data.code === '00') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            })
        },
        // 导出询价函
        exportRfq(rec) {
            exportRfq(rec).then(data => {
                if (data && data.code === '00') {

                    console.log(data)
                    this.readAsBinaryString(data.body)
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 1500,
                        onClose: () => {
                            // this.getDataList()
                        }
                    })
                } else {
                    this.$message.error(data.msg)
                }
            })
        },
        readAsBinaryString(data) {
            // const name = decodeURI(res.headers['content-disposition'].split('filename=')[1]);
            // const blob = new Blob(content, {type: 'application/vnd.ms-excel;charset=utf-8'}); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
            const blob = this.str2Blob(data.content, 'application/msword;charset=utf-8'); // 创建一个类文件对象：Blob对象表示一个不可变的、原始数据的类文件对象
            const url = window.URL.createObjectURL(blob); // URL.createObjectURL(object)表示生成一个File对象或Blob对象
            let dom = document.createElement('a'); // 设置一个隐藏的a标签，href为输出流，设置download
            dom.style.display = 'none';
            dom.href = url;
            dom.setAttribute('download', decodeURI(data.fileName)); // 指示浏览器下载url,而不是导航到它；因此将提示用户将其保存为本地文件
            document.body.appendChild(dom);
            dom.click();
        },
        str2Blob(str, mime) {
            var arr = str.split(',')
            var bstr = atob(arr[0]),
                n = bstr.length,
                u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {
                type: mime
            });
        },
        // 导出价格确认书
        exportConfirm(rec) {
            exportConfirm(rec).then(data => {
                if (data && data.code === '00') {
                    console.log(data)
                    this.readAsBinaryString(data.body)
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 1500,
                        onClose: () => {
                            // this.getDataList()
                        }
                    })
                } else {
                    this.$message.error(data.msg)
                }
            })
        },
        getStatusClass(status) {
            let className = ''
            switch (status) {
                case '0':
                    className = "text-primary"
                    break;
                case '6b':
                    className = "text-danger"
                    break;
                default:
                    className = 'text-success'
                    break;
            }
            return className
        }
    }
}
</script>
